import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { getProtectedResourcesMap } from '@core-factories';
import { catchError, switchMap, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(MsalService);
  const scopes = Array.from(getProtectedResourcesMap().keys()).find(domain =>
    req.url.includes(domain),
  );
  const activeAccount = authService.instance.getActiveAccount();

  if (scopes && activeAccount) {
    return authService
      .acquireTokenSilent({
        scopes: ['User.Read'],
        forceRefresh: false,
        account: activeAccount,
      })
      .pipe(
        switchMap(tokenResponse => {
          return next(
            req.clone({
              headers: req.headers.set(
                'Authorization',
                `Bearer ${tokenResponse.idToken}`,
              ),
            }),
          );
        }),
        catchError(error => {
          if (error.name === 'InteractionRequiredAuthError') {
            return authService
              .acquireTokenRedirect({
                scopes: ['User.Read'],
              })
              .pipe(switchMap(() => next(req)));
          } else {
            return throwError(() => error);
          }
        }),
      );
  } else {
    return next(req);
  }
};
